import { environment } from '../environments/environment';

type ChangeReason = 'FORGOTTEN_PASSWORD' | 'CHANGE_REQUEST';

const RESET_URL = environment.resetPasswordEndpoint as string;

/**
 *
 * @param email email address to send the password change request to
 * @param reason reason for the password change request
 * @returns {void}
 */
export async function requestPasswordChange(email: string, reason: ChangeReason): Promise<void> {
  const response = await fetch(RESET_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email: email, reason }),
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
}
